import { createContractRequest } from './helper';
export const getCheckPolicyReplacementApplication = createContractRequest({
    route: '/contract/offers/:offerId/checkPolicyReplacementApplication',
    method: 'get',
    source: 'data',
});
